import { smButtonClassName } from "@/components/AdminPanel/Organization/components/manage-pane-primitives";
import { Button } from "@/components/ui/button";
import { config } from "@/config";
import {
  MIN_MACOS_MAJOR,
  useDesktopAppEligibility,
} from "@/native/desktopShell";
import * as analytics from "@/utils/analytics";
import { Monitor } from "lucide-react";
import React from "react";

/**
 * Settings·Profile nudge to install the Cohesive desktop app. Renders only
 * when the machine can verifiably run it: a macOS desktop browser (not the
 * shell itself, not mobile), Apple silicon, macOS 13+ — see
 * src/native/desktopShell.ts for why "verifiably" excludes Safari/Firefox.
 *
 * The stable download URL is republished by every desktop release
 * (.github/actions/deploy-desktop-to-s3), so this link never goes stale.
 */

const DOWNLOAD_URL =
  config.appEnv === "prod"
    ? "https://downloads.cohesive.ai/desktop/releases/Cohesive.dmg"
    : "https://downloads.dev.cohesive.ai/desktop/releases/Cohesive.dmg";

export const DesktopAppBanner: React.FC = () => {
  const eligible = useDesktopAppEligibility();
  if (!eligible) return null;

  return (
    <div className="mx-2.5 flex items-center gap-3 rounded-lg border border-n-20 bg-n-05 py-2.5 pl-6 pr-5">
      <Monitor className="size-4 shrink-0 text-n-70" aria-hidden />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          {/* LcBadge's active-tone recipe without its lifecycle dot — "NEW"
              is a marketing marker, not a status on the lifecycle ladder. */}
          <span
            className="inline-flex shrink-0 items-center rounded-sm px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
            style={{
              backgroundColor:
                "color-mix(in oklab, var(--lc-active) 12%, transparent)",
              color: "color-mix(in oklab, var(--lc-active) 72%, var(--n-95))",
            }}
          >
            New
          </span>
          <div className="text-md font-medium text-n-90">Cohesive for Mac</div>
        </div>
        <div className="mt-0.5 text-sm text-n-50">
          Keep Cohesive in your dock. Requires macOS {MIN_MACOS_MAJOR} or newer.
        </div>
      </div>
      <Button
        size="sm"
        variant="secondary"
        className={smButtonClassName}
        onClick={() => {
          analytics.trackDesktopAppDownloadClicked();
          window.location.href = DOWNLOAD_URL;
        }}
      >
        Download
      </Button>
    </div>
  );
};

export default DesktopAppBanner;
